import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import axios from "axios";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Success from "@/pages/Success";
import { AuthProvider, ProtectedRoute, AuthCallback } from "@/lib/AuthContext";
import { useLenis } from "@/hooks/useLenis";

axios.defaults.withCredentials = true;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter({ dark, toggleTheme }) {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing dark={dark} toggleTheme={toggleTheme} />} />
      <Route path="/admin" element={<ProtectedRoute><Admin dark={dark} toggleTheme={toggleTheme} /></ProtectedRoute>} />
      <Route path="/success" element={<Success />} />
    </Routes>
  );
}

function App() {
  const [dark, setDark] = useState(() => localStorage.getItem("theme") !== "light");
  useLenis();

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <div className="App grain">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <AuthProvider>
          <AppRouter dark={dark} toggleTheme={() => setDark(!dark)} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
